import { render } from "./LookbookIndexFilters.vue?vue&type=template&id=39422282"
import script from "./LookbookIndexFilters.vue?vue&type=script&setup=true&lang=js"
export * from "./LookbookIndexFilters.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/Sales/LookbookIndexFilters.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "39422282"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('39422282', __exports__)) {
    api.reload('39422282', __exports__)
  }
  
  module.hot.accept("./LookbookIndexFilters.vue?vue&type=template&id=39422282", () => {
    api.rerender('39422282', render)
  })

}


export default __exports__